export default "__VITE_ASSET__COQ4V8Ka__"